import { createAction } from '@reduxjs/toolkit';
import type {
  ContextControl,
  Dashboard,
  FilterControl,
  PeriodControl,
  SettingsControl,
} from 'lib-analytics-types';

import { AnalyticsUIState } from './analytics.reducer';

const prefix = 'analytics';

export const analyticsActions = {
  setDashboard: createAction<{ dashboard: Dashboard }>(
    `${prefix}/setDashboard`,
  ),
  setQuickView: createAction<{
    id: string;
  }>(`${prefix}/setQuickView`),

  setContext: createAction<{ context: ContextControl }>(`${prefix}/setContext`),
  setPeriod: createAction<{ period: PeriodControl }>(`${prefix}/setPeriod`),
  setFilters: createAction<{ filters: FilterControl[] }>(
    `${prefix}/setFilters`,
  ),
  setSettings: createAction<{
    settings: Partial<SettingsControl>;
    period?: PeriodControl;
  }>(`${prefix}/setSettings`),
  setUI: createAction<{ ui: Partial<AnalyticsUIState> }>(`${prefix}/setUI`),

  forceRefresh: createAction(`${prefix}/forceRefresh`),
};
